/**
 * Normalizes node properties that may arrive as:
 * - `null`/`undefined`/empty
 * - a JSON string
 * - an object
 *
 * Returns a plain object for downstream consumption.
 */
const normalizeNodeProperties = (properties = {}) => {
    if (!properties || typeof properties !== 'object') {
        return {};
    }

    const normalized = { ...properties };
    if (normalized.process_nature == null && normalized.flow_type != null) {
        normalized.process_nature = normalized.flow_type;
    }

    return normalized;
};

export const parseNodeProperties = (rawProperties, { onError } = {}) => {
    if (!rawProperties) {
        return {};
    }

    if (typeof rawProperties === 'string') {
        try {
            const parsed = JSON.parse(rawProperties);
            return normalizeNodeProperties(parsed && typeof parsed === 'object' ? parsed : {});
        } catch (error) {
            if (typeof onError === 'function') {
                onError(error);
            }
            return {};
        }
    }

    if (typeof rawProperties === 'object') {
        return normalizeNodeProperties(rawProperties);
    }

    return {};
};

/**
 * Variant for callers that historically use `null` to mean "no valid properties".
 */
export const parseNodePropertiesOrNull = (rawProperties, options) => {
    const parsed = parseNodeProperties(rawProperties, options);
    return Object.keys(parsed).length ? parsed : null;
};
